import useAPI from '@/hooks/useAPI';
import AddressRepository from '@/repositories/AddressRepository';
import { Address } from '@/types/person';

export const useValidateAddress = (address: Address) => {
  const addressRepository = AddressRepository();

  return useAPI({
    queryKey: ['validateAddress', address],
    queryFn: async () => {
      return await addressRepository.validate(address);
    }
  });
};

export default useValidateAddress;
